let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("fliVL"), load("9CNF8")]).then(() => parcelRequire('lukLO'));